import { useState, useEffect } from 'react';
import { Link, useHistory } from 'react-router-dom';
import Api from '../api/api';
import Enums from '../../utilities/enum';
import Modal from 'react-bootstrap/Modal';
import Loader from '../shared/loader';
import { useToasts } from 'react-toast-notifications'
import UploadFile from '../shared/file-uploader';
import Payments from './_payments';
import BreachPayments from './_breachPayments';
import RedactionPane from './_redactionPane';
import OutstandingBalancePane from './_outstandingBalancePane';
import roleUtilities from '../../utilities/roleUtilities';
import AllowedVrms from './_allowedVrms';
import arrayUtilities from '../../utilities/arrayUtilities';
import stringHelpers from '../../utilities/stringHelpers';
import { ErrorModal } from '../../utilities/errorModal';
import formUtilities from '../../utilities/formUtilities';
import { toDateString, toTimeString, durationBetweenString, toDateTimeString, sortArrayOfObjectsByTimestampProperty, timeAgo, toInputFieldDateTimeString, areDatesEqual } from '../../utilities/dateUtilities';
import { SearchSelect } from '../shared/searchSelect';
import { BreachAttachmentsDisplay } from '../shared/breachAttachmentsDisplay';

var cloneDeep = require('lodash.clonedeep');

function BreachOldLayout(props) {
    const isThirdPartyUser = roleUtilities.isThirdPartyProcessor(props.user, props.organisationId) || roleUtilities.isThirdPartyManager(props.user, props.organisationId)

    const [isLoading, setIsLoading] = useState(true);
    const [breachId, setBreachId] = useState(props.breachId)
    const [breach, setBreach] = useState(null);
    const [breaches, setBreaches] = useState(null);
    const [site, setSite] = useState(null);
    const [allocatedBreaches, setAllocatedBreaches] = useState(null);

    const [numberOfBreaches, setNumberOfBreaches] = useState(0);

    const [message, setMessage] = useState("");

    const [allContraventions, setAllContraventions] = useState(null);
    const [siteContraventions, setSiteContraventions] = useState(null);
    const [selectedSiteByClient, setSelectedSiteByClient] = useState(null)
    const [ticketDetailsInEdit, setTicketDetailsInEdit] = useState(false)
    const [ticketDetailsLookupError, setTicketDetailsLookupError] = useState(null)
    const [successfulLookupVrm, setSuccessfulLookupVrm] = useState(null)
    
    const [loadingVehicleLookup, setLoadingVehicleLookup] = useState(false)
    
    const [observedFrom, setObservedFrom] = useState(null)
    const [observedTo, setObservedTo] = useState(null)
    const [duration, setDuration] = useState(null)
    const [dupeTicket, setDupeTicket] = useState(null);
    const [vrm, setVrm] = useState("");
    const [contraventionId, setContraventionId] = useState(null);

    const [canSave, setCanSave] = useState(false);
    const [clients, setClients] = useState(null);

    const [note, setNote] = useState("");
    const [reasons, setReasons] = useState(null);
    const [cancelReason, setCancelReason] = useState(null);
    const [canCancel, setCanCancel] = useState(false);

    const [contraventionValidation, setContraventionValidation] = useState(null)
    const [lookupDataInEdit, setLookupDataInEdit] = useState(false);
    const [lookupColour, setLookupColour] = useState("");
    const [lookupModel, setLookupModel] = useState("");
    const [lookupMake, setLookupMake] = useState("");

    const [attachments, setAttachments] = useState(null);
    const [deleteAttachmentId, setDeleteAttachmentId] = useState(null)    
    const [contactDetailsList, setContactDetailsList] = useState(null);
    const [newContactUrl, setNewContactUrl] = useState("/");
    const [status, setStatus] = useState(null);
    const [showChangeStatus, setShowChangeStatus] = useState(false);
    const [appeals, setAppeals] = useState(null);
    const [transfers, setTransfers] = useState(null);
    const [previousContraventions, setPreviousContraventions] = useState(null);

    const [prevUrl, setPrevUrl] = useState(null);
    const [nextUrl, setNextUrl] = useState(null);
    const [batchIndex, setBatchIndex] = useState(-1);
    const [batchLength, setBatchLength] = useState(-1);
    const [errorMessage, setErrorMessage] = useState(null);
    const [isOnHoldExpiry, setIsOnHoldExpiry] = useState("")

    const [showAddCharge, setShowAddCharge] = useState(false)
    const [showDeleteCharge, setShowDeleteCharge] = useState(false)
    const [additionalCharges, setAdditionalCharges] = useState(null)
    const [additionalChargeId, setAdditionalChargeId] = useState(null)
    const [additionalChargeAmount, setAdditionalChargeAmount] = useState("")
    const [additionalChargeDescription, setAdditionalChargeDescription] = useState("")
    const [timestamp, setTimestamp] = useState(new Date().getTime());
    const [paymentsFromDate, setPaymentsFromDate] = useState(null);
    const [paymentsToDate, setPaymentsToDate] = useState(null);
    const { addToast } = useToasts();
    const history = useHistory();

    const [showAppeal, setShowAppeal] = useState(false);
    const [showTransfer, setShowTransfer] = useState(false);

    const handleCloseAppeal = () => setShowAppeal(false);
    const handleShowAppeal = () => setShowAppeal(true);
    const handleCloseTransfer = () => setShowTransfer(false);
    const handleShowTransfer = () => setShowTransfer(true);

    var _breachesAbortController = null;
    var _allocatedBreachesAbortController = null;

    const getReasons = function () {
        Api.getCancellationReasons(
            (data) => setReasons(data),
            (error) => console.log(error),
            props.organisationId,
            props.token
        )
    };

    const getSiteContraventions = function (siteId) {
        Api.getSiteContraventions(
            (data) => {
                setSiteContraventions(data)
                if (arrayUtilities.isNullOrEmpty(data)) {
                    setContraventionValidation("This site has no contraventions configured")
                    setContraventionId(null)
                } else {
                    setContraventionValidation(null)
                }
            },
            (error) => console.log(error),
            props.organisationId,
            siteId,
            props.token
        )
    };

    const getAllContraventions = function () {
        Api.getContraventions(
            (data) => setAllContraventions(data),
            (error) => console.log(error),
            props.organisationId,
            props.token
        )
    };

    const getPreviousContraventions = function () {
        if (vrm !== null && vrm !== "") {
            Api.getBreaches(
                (data) => {
                    if (data && data !== null && data.items !== null && data.items.length > 0) {
                        setPreviousContraventions(data.items.filter(x => x.id !== breachId))
                    } else {
                        setPreviousContraventions([]);
                    }
                },
                (error) => console.log(error),
                vrm, null, null, null, null, null, null, null, null, 0, 0, null, null, null,
                null, null,
                null,
                props.organisationId,
                props.token,
                null
            )
        }
    };

    const getBreach = function () {
        setIsLoading(true);
        Api.getBreach(
            (data) => {
                setBreach(data);
                setSelectedSiteByClient(data.siteId)
                setTimestamp(new Date().getTime());
                setContraventionId(data.contraventionId)
                setObservedFrom(data.parkingSession?.entry?.timestamp)
                setObservedTo(data.parkingSession?.exit?.timestamp)
                setDuration(
                    durationBetweenString(data.parkingSession?.entry?.timestamp, data.parkingSession?.exit?.timestamp)
                )
                setIsLoading(false);
            },
            (error) => {
                console.log(error)
                setIsLoading(false)
            },
            breachId,
            props.organisationId,
            props.token
        )
    };

    const getAttachments = function () {
        Api.getBreachAttachments(
            (data) => {
                let attachmentsData = []
                if (breach && !arrayUtilities.isNullOrEmpty(breach.emails)) {
                    attachmentsData = breach.emails.map(email => ({
                        ...email,
                        isEmail: true
                    }))
                }
                if (!arrayUtilities.isNullOrEmpty(data)) {
                    attachmentsData = [...attachmentsData, ...data]
                }
                const sortByTimestamp = sortArrayOfObjectsByTimestampProperty(attachmentsData)
                setAttachments(sortByTimestamp)
            },
            (error) => console.log(error),
            props.organisationId,
            breachId, props.token
        )
    };

    const getBreaches = function () {
        if (_breachesAbortController) {
            _breachesAbortController.abort();
        }
        _breachesAbortController = new AbortController();
        const signal = _breachesAbortController.signal;
        Api.getBreaches(
            (data) => setBreaches(data.items),
            (error) => console.log(error),
            breach.vrm, null, null, null, null, null, null, null, null, 0, 0, null, null, null,
            null, null,
            null,
            props.organisationId,
            props.token,
            signal
        )
    };

    const getSite = function () {
        Api.getSite(
            (data) => setSite(data),
            () => { },
            breach.siteId, props.organisationId, props.token);
    }

    const ticketAction = function (content, toastType) {
        addToast(content, {
            appearance: toastType,
            autoDismiss: true,
        })
    };

    const setOnHold = function (onHold) {
        Api.onHoldTicket(
            () => {
                getBreach();
                setMessage("")
                setIsOnHoldExpiry("")
                if (onHold) {
                    autoShowNextBreach()
                }
            },
            (error) => console.log(error),
            message,
            breachId,
            onHold,
            !stringHelpers.isNullOrEmpty(isOnHoldExpiry) ? isOnHoldExpiry : null,
            props.organisationId,
            props.token
        )
    };

    const getClients = () => {
        Api.getClients(
            data => setClients(data),
            error => console.log(error),
            props.organisationId,
            props.token
        )
    }

    const attachFile = function (file) {
        Api.addBreachAttachment(
            () => getAttachments(),
            file.id, breachId, props.organisationId, props.token
        )
    };

    const getAllocatedBreaches = function () {
        if (_allocatedBreachesAbortController) {
            _allocatedBreachesAbortController.abort();
        }
        _allocatedBreachesAbortController = new AbortController();
        const signal = _allocatedBreachesAbortController.signal;
        Api.getBreaches(
            (data) => setAllocatedBreaches(data.items),
            (error) => console.log(error),
            null, null, props.user.id, true, null, null, null, null, null, 0, 0, null, null, null,
            null, null,
            null,
            props.organisationId,
            props.token,
            signal
        )
    };

    const submitNote = function () {
        if (!stringHelpers.isNullOrEmpty(note)) {
            Api.attachNoteToTicket(
                () => {
                    getBreach();
                    setNote(null);
                },
                (error) => console.log(error),
                note, breachId,
                props.organisationId,
                props.token
            )
        }
    };

    const getAppeals = function () {
        Api.getAppeals(
            (data) => setAppeals(data),
            (error) => console.log(error),
            breachId,
            props.organisationId,
            props.token
        )
    };

    const editBreach = function (selectedSite) {
        const isMnpr = allContraventions?.find(x => x.id === contraventionId)?.contraventionType === 1
        Api.editBreach(
            (data) => {
                if (data.isError) {
                    setErrorMessage(data.errorMessage)
                } else {
                    setSelectedSiteByClient(data.siteId)
                    getSiteContraventions(data.siteId)
                    setBreach(data);
                    setContraventionId(data.contraventionId)
                    setLookupDataInEdit(false);
                    setTicketDetailsInEdit(false)
                    setDuration(
                        durationBetweenString(data.parkingSession?.entry?.timestamp, data.parkingSession?.exit?.timestamp)
                    )
                }
                setIsLoading(false)
            },
            error => {
                setErrorMessage(error.errorMessage);
                setIsLoading(false)
            },
            vrm, lookupMake, lookupModel, lookupColour, contraventionId, breachId, selectedSite, isMnpr ? new Date(observedFrom).toISOString() : null, isMnpr ? new Date(observedTo).toISOString() : null, props.organisationId, props.token
        )
    };

    const getTransfers = function () {
        Api.getTransfersLiability(
            (data) => setTransfers(data),
            (error) => { },
            breachId,
            props.organisationId,
            props.token
        )
    };

    const cancelTicket = function () {
        if (canCancel) {
            Api.cancelTicket(
                () => {
                    getBreach();
                    ticketAction('Ticket Cancelled Successfully', 'error');
                    autoShowNextBreach()
                },
                (error) => console.log(error),
                cancelReason.id,
                props.organisationId,
                breachId,
                props.token
            )
        }
    };

    const readyForLetters = function () {
        if (contactDetailsList.length !== 0) {
            Api.setReadyForLetters(
                (data) => {
                    getBreach();
                },
                (error) => console.log(error),
                "", breachId, props.organisationId, props.token
            )
        }
    };

    const getContactDetails = function () {
        Api.getAllContacts(
            (data) => setContactDetailsList(data),
            (error) => console.log(error),
            breachId, props.organisationId, props.token
        )
    };

    const cancelChangeStatus = function () {
        setStatus(breach.breachStatus);
        setNote(null);
        setShowChangeStatus(false);
    };

    const changeStatus = function () {
        setShowChangeStatus(false);

        Api.setBreachStatus(
            () => {
                getBreach();
                setNote(null);
            },
            (error) => console.log(error),
            note,
            breachId,
            status,
            props.organisationId,
            props.token
        )
    };

    const onSaveReducedCharge = function (reducedChargeDays, reducedChargeAmount) {
        setIsLoading(true);

        Api.setBreachReducedCharge(
            () => {
                getBreach();
            },
            (error) => console.log(error),
            breachId,
            reducedChargeDays,
            reducedChargeAmount,
            props.organisationId,
            props.token
        );
    }

    useEffect(() => {
        if (breach !== null) {
            setVrm(breach.vrm);
            setStatus(breach.breachStatus);

            if (breaches && breaches !== null && breaches.length > 0) {
                var total = 0;

                breaches.forEach(item => {
                    if (item.vrm === breach.vrm) {
                        total++;
                        if (areDatesEqual(item.timestamp, breach.timestamp) && item.id !== breach.id) {
                            setDupeTicket(item)
                        }
                    }
                });
                setNumberOfBreaches(total);
            }
        } else {
            getBreach();
        }
    }, [breach, breaches]);

    useEffect(() => {
        if (vrm !== null) {
            setVrm(vrm.toUpperCase());
        }
    }, [vrm]);

    const addNewAppeal = function () {
        history.push("/organisation/" + props.organisationId + "/breach/" + breachId + "/appeal");
    };

    const deleteAppeal = function (appealId) {
        Api.deleteAppeal(() => {
            getBreach();
        }, () => {
            alert("Error deleting appeal");
        }, breachId, appealId, props.organisationId, props.token);
    }

    const addNewTransfer = function () {
        history.push("/organisation/" + props.organisationId + "/breach/" + breachId + "/transfer-of-liability");
    };

    const attachmentIsLetterImage = function (attachmentId, isLetterImage) {
        let attachmentsClone = cloneDeep(attachments);
        let targetIndex = attachmentsClone.findIndex(x => x.id === attachmentId);

        if (targetIndex >= 0) {
            attachmentsClone[targetIndex].isLetterImage = isLetterImage;
        }

        setAttachments(attachmentsClone);
        Api.setBreachAttachmentIsLetterImage(() => {

        }, () => {

        }, props.organisationId, props.id, attachmentId, isLetterImage, props.token)
    }

    useEffect(() => {
        if (!isLoading && breach && breach !== null && status !== breach.breachStatus) {
            if (status === 200) {
                handleShowAppeal();
            } else if (status === 210) {
                handleShowTransfer();
            } else {
                setShowChangeStatus(true);
            }
        }
    }, [status]);

    useEffect(() => {
        if (cancelReason !== null) {
            setCanCancel(true);
        } else {
            setCanCancel(false);
        }
    }, [cancelReason]);

    useEffect(() => {
        setBreachId(props.breachId);
    }, [props.breachId])

    useEffect(() => {
        if (!arrayUtilities.isNullOrEmpty(allocatedBreaches) && breachId !== null) {

            setBatchLength(allocatedBreaches.length);

            let index = allocatedBreaches.findIndex(x => x.id === breachId);

            if (index > -1) {

                setBatchIndex(index);
                if (index !== 0) {
                    setPrevUrl("/organisation/" + props.organisationId + "/breach/" + allocatedBreaches[index - 1].id);
                } else {
                    setPrevUrl("/organisation/" + props.organisationId + "/breach/" + allocatedBreaches[allocatedBreaches.length - 1].id);
                }
                if (index !== allocatedBreaches.length - 1) {
                    setNextUrl("/organisation/" + props.organisationId + "/breach/" + allocatedBreaches[index + 1].id);
                } else {
                    setNextUrl("/organisation/" + props.organisationId + "/breach/" + allocatedBreaches[0].id);
                }
            } else {
                setPrevUrl(null);
                setNextUrl(null);
            }
        } else {
            setPrevUrl(null);
            setNextUrl(null);
        }
    }, [allocatedBreaches]);

    useEffect(() => {
        if (breachId !== null) {
            getBreach();
            setNewContactUrl("/organisation/" + props.organisationId + "/breach/" + breachId + "/contact-details");
        }
        getAllContraventions();
        getReasons();
    }, [breachId]);

    useEffect(() => {
        if (breach !== null) {
            if (breach.vehicleMake !== null) {
                setLookupMake(breach.vehicleMake);
            } else {
                setLookupMake(null);
            }
            if (breach.vehicleColour !== null) {
                setLookupColour(breach.vehicleColour);
            } else {
                setLookupColour(null);
            }
            if (breach.vehicleModel !== null) {
                setLookupModel(breach.vehicleModel);
            } else {
                setLookupModel(null);
            }
        }
    }, [lookupDataInEdit, breach]);

    const reloadImages = function () {
        getBreach();
    };

    useEffect(() => {
        if (breach !== null) {
            getBreaches();
            getSite();
            getSiteContraventions(breach.siteId);
            getAdditionalCharges()
            const breachDate = new Date(breach.timestamp);
            const toDate = new Date(Date.UTC(breachDate.getFullYear(), breachDate.getMonth(), breachDate.getDate() + 1, 23, 59, 59));
            const fromDate = new Date(Date.UTC(breachDate.getFullYear(), breachDate.getMonth(), breachDate.getDate() - 1, 0, 0, 0));
            setPaymentsToDate(toDate)
            setPaymentsFromDate(fromDate)
        }
        getAppeals();
        getAttachments();
        getContactDetails();
        getPreviousContraventions();
        getTransfers();
    }, [breach]);

    useEffect(() => {
        if (!stringHelpers.isValidVrm(vrm)) {
            setCanSave(false);
        } else {
            setCanSave(true);
        }
    }, [vrm]);

    useEffect(() => {
        getAllocatedBreaches();
        getClients();
    }, []);

    const autoShowNextBreach = () => {
        if (!stringHelpers.isNullOrEmpty(nextUrl)) {
            history.push(nextUrl)
        }
    }

    const getAdditionalCharges = () => {
        Api.getAdditionalCharges(
            data => setAdditionalCharges(data),
            error => console.log(error),
            breachId,
            props.organisationId,
            props.token
        )
    }

    const saveAdditionalCharge = () => {
        if (additionalChargeId) {
            Api.editAdditionalCharge(
                data => {
                    if (data.isError) {
                        setShowAddCharge(false)
                        setErrorMessage(data.errorMessage)
                    } else {
                        setShowAddCharge(false)
                        getAdditionalCharges()
                        getBreach()
                    }
                },
                error => {
                    setShowAddCharge(false)
                    setErrorMessage(error.message)
                },
                breachId, additionalChargeId, additionalChargeAmount, additionalChargeDescription,
                props.organisationId, 
                props.token
            )
        } else {
            Api.addAdditionalCharge(
            data => {
                if (data.isError) {
                    setErrorMessage(data.errorMessage)
                } else {
                    setShowAddCharge(false)
                    setAdditionalChargeAmount("")
                    setAdditionalChargeDescription("")
                    getAdditionalCharges()
                    getBreach()
                }
            },
            error => {
                console.log(error)
                setShowAddCharge(false)
                setErrorMessage(error.message)
            }, 
            breachId, Number(additionalChargeAmount), additionalChargeDescription,
            props.organisationId,
            props.token
        )
        }
    }

    const breachStatusOptionsByRole = () => {
        const thirdPartyAllowedStatuses = ["220", "221", "222", "223", "224", "225", "308", "321", "322"]
        const allOptions = Object.entries(Enums.BreachStatus)
        const options = (isThirdPartyUser || roleUtilities.isOrganisationProcessor(props.user, props.organisationId))
            ? allOptions
                .filter(([key]) => (thirdPartyAllowedStatuses.includes(key)))
            : allOptions


        if (options.findIndex(item => item[0] === String(status)) === -1) {
            options.push([String(status), Enums.BreachStatus[status]])
        }
        return options.map(([key, value]) => ({value: key, label: value}))
    }

    const imageAttachments = attachments
        ? attachments.filter(attachment => attachment.isImage).map(attachment => ({ ...attachment, url: attachment.url + '&ts=' + timestamp }))
        : [];

    return (
        <>
            {isLoading &&
                <Loader />
            }
            {!isLoading && breach && breach !== null && <>
                <div className="container-fluid">
                    <div className="row">
                        <div className="col-12 px-0">
                            <div className="card mb-3">
                                <div className="modal fade" id="cancel-modal" tabIndex="-1" role="dialog" aria-labelledby="Cancel Modal" aria-hidden="true">
                                    <div className="modal-dialog" role="document">
                                        <div className="modal-content">
                                            <div className="modal-header">
                                                <h5 className="modal-title" id="deleteModalLabel">Select a reason to cancel this ticket.</h5>
                                                <button type="button" className="close" data-dismiss="modal" aria-label="Close">
                                                    <span aria-hidden="true">&times;</span>
                                                </button>
                                            </div>
                                            <div className="modal-body">
                                                <div className="row">
                                                    <div className="col-12 ">
                                                        <p className="font-weight-semi-bold  mt-1 mb-2">Reason:</p>
                                                    </div>
                                                    <div className="col-12 ">
                                                        <div className="form-group mb-0">
                                                            <div className="dropdown ">
                                                                <button className="btn btn-falcon-default dropdown-toggle btn-sm mb-1 edit-dropdown" id="select-type" type="button" data-toggle="dropdown" aria-haspopup="true" aria-expanded="false">{cancelReason !== null && cancelReason.name}{cancelReason === null && <>Select Reason</>}</button>
                                                                <div className="dropdown-menu py-0 edit-dropdown" aria-labelledby="select-type" >
                                                                    <div className="bg-white py-2 rounded-soft">
                                                                        {reasons !== null && reasons.map((reason) => {
                                                                            return (
                                                                                <button className="dropdown-item text-base px-3 py-2" onClick={() => setCancelReason(reason)}>{reason.name}</button>
                                                                            )
                                                                        })}
                                                                    </div>
                                                                </div>
                                                            </div>
                                                        </div>
                                                    </div>
                                                </div>
                                            </div>
                                            <div className="modal-footer">
                                                <button type="button" className="btn btn-falcon-default btn-sm ml-2" data-dismiss="modal">Cancel</button>
                                                <button type="button" className="btn btn-success btn-sm ml-2" disabled={!canCancel} data-dismiss="modal" onClick={() => cancelTicket()}>
                                                    Confirm</button>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                                <div className="modal fade" id="on-hold-modal" tabIndex="-1" role="dialog" aria-labelledby="On Hold Modal" aria-hidden="true">
                                    <div className="modal-dialog" role="document">
                                        <div className="modal-content">
                                            <div className="modal-header">
                                                <h5 className="modal-title" id="deleteModalLabel">Add a note to place this ticket On Hold.</h5>
                                                <button type="button" className="close" data-dismiss="modal" aria-label="Close">
                                                    <span aria-hidden="true">&times;</span>
                                                </button>
                                            </div>
                                            <div className="modal-body">
                                                <div className="row align-items-center">
                                                    <div className="col-12 ">
                                                        <p className="font-weight-semi-bold mt-1 mb-2">Expiry Date</p>
                                                    </div>
                                                    <div className="col-12">
                                                        <div className="form-group mb-1">
                                                            <input className="form-control mb-0" type="date" value={ stringHelpers.isNullOrEmpty(isOnHoldExpiry) ? null : isOnHoldExpiry } onChange={ (e) => setIsOnHoldExpiry(e.target.value) } />
                                                        </div>
                                                    </div>
                                                </div>
                                                <div className="row">
                                                    <div className="col-12 ">
                                                        <p className="font-weight-semi-bold  mt-1 mb-2">Note:</p>
                                                    </div>
                                                    <div className="col-12">
                                                        <div className="form-group mb-0">
                                                            <textarea className="form-control mb-0" rows={4} value={message} onChange={(e) => setMessage(e.target.value)} />
                                                        </div>
                                                    </div>
                                                </div>
                                            </div>
                                            <div className="modal-footer">
                                                <button type="button" className="btn btn-falcon-default btn-sm ml-2" data-dismiss="modal">Cancel</button>
                                                <button disabled={stringHelpers.isNullOrEmpty(message)} type="button" className="btn btn-success btn-sm ml-2" data-dismiss="modal" onClick={() => setOnHold(true)}>
                                                    Confirm</button>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                                <Modal show={showChangeStatus} onHide={cancelChangeStatus} size="lg">
                                    <Modal.Header>
                                        <Modal.Title>
                                            Add a note to set status to {Enums.BreachStatus[status]}
                                        </Modal.Title>
                                    </Modal.Header>
                                    <Modal.Body>
                                        <div className="row">
                                            <div className="col-12 ">
                                                <p className="font-weight-semi-bold  mt-1 mb-2">Note:</p>
                                            </div>
                                            <div className="col-12">
                                                <div className="form-group mb-0">
                                                    <textarea className="form-control mb-0" rows={4} value={note} onChange={(e) => setNote(e.target.value)} />
                                                </div>
                                            </div>
                                        </div>
                                    </Modal.Body>
                                    <Modal.Footer>
                                        <button className="btn btn-sm btn-danger mt-1" onClick={cancelChangeStatus}>Cancel</button>
                                        <button className="btn btn-sm btn-success mt-1" disabled={stringHelpers.isNullOrEmpty(note)} onClick={changeStatus}>Confirm</button>
                                    </Modal.Footer>
                                </Modal>
                                <Modal show={showAppeal} onHide={handleCloseAppeal}>
                                    <Modal.Header>
                                        <Modal.Title>
                                            <div className="row justify-content-between">
                                                <div className="col-11">
                                                    Do you want to add a new Appeal?
                                                </div>
                                                <div className="col-1">
                                                    <button type="button" className="close" onClick={handleCloseAppeal}>
                                                        <span aria-hidden="true">&times;</span>
                                                    </button>
                                                </div>
                                            </div>
                                        </Modal.Title>
                                    </Modal.Header>
                                    <Modal.Footer>
                                        <button className="btn btn-sm btn-danger mt-1" onClick={() => { handleCloseAppeal(); setStatus(breach.breachStatus); }}>Cancel</button>
                                        <button className="btn btn-sm btn-success mt-1" onClick={() => { handleCloseAppeal(); addNewAppeal(); }}>Confirm</button>
                                    </Modal.Footer>
                                </Modal>
                                <Modal show={showTransfer} onHide={handleCloseTransfer}>
                                    <Modal.Header>
                                        <Modal.Title>
                                            <div className="row justify-content-between">
                                                <div className="col-11">
                                                    Do you want to add a new Transfer of Liability?
                                                </div>
                                                <div className="col-1 text-right">
                                                    <button type="button" className="close" onClick={handleCloseTransfer}>
                                                        <span aria-hidden="true">&times;</span>
                                                    </button>
                                                </div>
                                            </div>
                                        </Modal.Title>
                                    </Modal.Header>
                                    <Modal.Footer>
                                        <button className="btn btn-sm btn-danger mt-1" onClick={() => { handleCloseTransfer(); setStatus(breach.breachStatus); }}>Cancel</button>
                                        <button className="btn btn-sm btn-success mt-1" onClick={() => { handleCloseTransfer(); addNewTransfer(); }}>Confirm</button>
                                    </Modal.Footer>
                                </Modal>
                                <div className="card-body bg-light border-top details-container">
                                    <div className="row">
                                        <div className='col-sm-6'>
                                            <div className="row mb-2">
                                                <label class="col-sm-4 col-form-label col-form-label-sm">Breach Date</label>
                                                <div className="col-sm-8">
                                                    {breach.timestamp !== null &&
                                                        <p class="form-control-plaintext form-control-sm outline-none" >{toDateString(breach.timestamp)} ({timeAgo(breach.timestamp)})</p>
                                                    }
                                                </div>
                                            </div>
                                            <div className="row mb-2">
                                                <label class="col-sm-4 col-form-label col-form-label-sm">Breach Status</label>
                                                <div className=" col-sm-8">
                                                    {roleUtilities.isOrganisationAdminOrManager(props.user, props.organisationId) || isThirdPartyUser || roleUtilities.isOrganisationProcessor(props.user, props.organisationId) ?
                                                        <SearchSelect 
                                                            options={breachStatusOptionsByRole()}
                                                            onSelect={value => setStatus(Number(value))}
                                                            selected={String(status)}
                                                        />
                                                        : <p class="form-control-plaintext form-control-sm outline-none" >{Enums.BreachStatus[status]}</p>
                                                    }
                                                </div>
                                            </div>
                                            {
                                                breach.isCurrentlyOnHold &&
                                                    <div className="row mb-2">
                                                        <label class="col-sm-4 col-form-label col-form-label-sm">&nbsp;</label>
                                                        <div className="col-sm-8">
                                                            <p class="form-control-plaintext form-control-sm outline-none">
                                                                <i className='mr-1 fas fa-exclamation-triangle text-warning'></i>
                                                                On hold
                                                                { breach.isOnHoldExpiry && <> until { toDateString(breach.isOnHoldExpiry) }</> }
                                                            </p>
                                                        </div>
                                                    </div>
                                            }
                                            <div className="row mb-2">
                                                <label class="col-sm-4 col-form-label col-form-label-sm">Assigned To</label>
                                                <div className="col-sm-8">
                                                    <p class="form-control-plaintext form-control-sm outline-none" >    {breach.assignedToUserName}{breach.assignedToUserName === null && <>Unassigned</>}</p>
                                                </div>
                                            </div>
                                        </div>
                                        <div className="col-sm-6">
                                            <OutstandingBalancePane user={props.user} organisationId={props.organisationId} breach={breach} onSave={onSaveReducedCharge} />
                                        </div>
                                    </div>
                                </div>
                            </div>

                            <div className="card mb-3">
                                <div className="card-header">
                                    <div className="row align-items-center justify-content-between">
                                        <div className="col-1 d-flex align-items-center pr-0">
                                            <h5 className="fs-0 mb-0 text-nowrap py-2 py-xl-0">Vehicle and Ticket Details</h5>
                                        </div>
                                    </div>
                                </div>
                                <div className="card-body bg-light border-top details-container">
                                    <div className='mb-2' style={{display: "grid", gridTemplateColumns: "repeat(2, 1fr)", gap: "2rem"}}>
                                        <div>
                                            <div className="row mb-2">
                                                <label class="col-sm-4 col-form-label col-form-label-sm">Site{ticketDetailsInEdit && <span className="req"></span>}</label>
                                                <div className="col-sm-8">                                                                        
                                                    {
                                                        allContraventions?.find(x => x.id === breach.contraventionId)?.contraventionType === 1 && ticketDetailsInEdit 
                                                        ? <div>
                                                            <SearchSelect
                                                            options={ props.sites.map(item => ({ value: item.id, label: item.name })) }
                                                            onSelect={ value => {
                                                                setSelectedSiteByClient(value)
                                                                getSiteContraventions(value)
                                                            } }
                                                            selected={ selectedSiteByClient }
                                                            defaultLabel="All"
                                                        />
                                                        {stringHelpers.isNullOrEmpty(selectedSiteByClient) && <small className='text-danger'>Please select a site</small>}
                                                        </div>
                                                        : <p class="form-control-plaintext form-control-sm outline-none" >{ breach.siteName }</p>
                                                    }
                                                </div>
                                            </div>
                                            
                                            {!ticketDetailsInEdit && <>

                                                <div className="row align-items-center mb-2">
                                                    <label class="col-sm-4 col-form-label col-form-label-sm">VRM</label>
                                                    <div className="col-sm-8">
                                                        <p className="small-number-plate m-0">{breach.vrm}</p>
                                                    </div>
                                                </div>
                                                <div className="row mb-2">
                                                    <label class="col-sm-4 col-form-label col-form-label-sm">Vehicle Make</label>
                                                    <div className="col-sm-8">
                                                        <p class="form-control-plaintext form-control-sm outline-none" >{lookupMake}</p>
                                                    </div>
                                                </div>
                                                <div className="row mb-2">
                                                    <label class="col-sm-4 col-form-label col-form-label-sm">Vehicle Model</label>
                                                    <div className="col-sm-8">
                                                        <p class="form-control-plaintext form-control-sm outline-none" >{lookupModel}</p>
                                                    </div>
                                                </div>
                                                <div className="row mb-2">
                                                    <label class="col-sm-4 col-form-label col-form-label-sm">Vehicle Colour</label>
                                                    <div className="col-sm-8">
                                                        <p class="form-control-plaintext form-control-sm outline-none" >{lookupColour}</p>
                                                    </div>
                                                </div>
                                            </>}
                                            {ticketDetailsInEdit && <>
                                                <div className="row align-items-center mb-1">
                                                    <label class="col-sm-4 col-form-label col-form-label-sm">VRM<span className="req"></span></label>
                                                    <div className="col-sm-8">
                                                        <div className='d-flex align-items-center'>
                                                            <input required className="form-control form-control-sm mb-1" type="text" value={ vrm } onChange={ (e) => {
                                                                setVrm(e.target.value)
                                                                formUtilities.requiredField(e.target.parentNode, e.target.value)
                                                            } } />
                                                            <button
                                                                onClick={ () => {
                                                                    setLoadingVehicleLookup(true)
                                                                    Api.vehicleLookup(
                                                                        data => {
                                                                            if (data.isError) {
                                                                                setTicketDetailsLookupError(data.errorMessage)
                                                                            } else {
                                                                                setLookupMake(data.vehicleMake)
                                                                                setLookupModel(data.vehicleModel)
                                                                                setLookupColour(data.vehicleColour)
                                                                                setSuccessfulLookupVrm(vrm)
                                                                                setTicketDetailsLookupError(null)
                                                                            }
                                                                            setLoadingVehicleLookup(false)
                                                                        },
                                                                        () => {
                                                                            setTicketDetailsLookupError("Unable to find vehicle details")
                                                                            setLoadingVehicleLookup(false)
                                                                        },
                                                                        vrm.toLowerCase(),
                                                                        props.organisationId, props.token
                                                                    )
                                                                } }
                                                                disabled={
                                                                    stringHelpers.isNullOrEmpty(vrm) ||
                                                                    !stringHelpers.isValidVrm(vrm) ||
                                                                    (
                                                                        !stringHelpers.isNullOrEmpty(vrm) && !stringHelpers.isNullOrEmpty(successfulLookupVrm) && vrm === successfulLookupVrm
                                                                    ) ||
                                                                    loadingVehicleLookup
                                                                }
                                                                className='btn btn-falcon-default btn-sm mb-1 ml-2 text-nowrap'
                                                            >
                                                                <div className='d-flex align-items-center'>
                                                                    {
                                                                        loadingVehicleLookup
                                                                            ? <span className="tiny-loader mr-2"><Loader /></span>
                                                                            : <i className='fas fa-search mr-1'></i>
                                                                    }
                                                                    Vehicle Lookup
                                                                </div>
                                                            </button>
                                                        </div>
                                                        {
                                                            !stringHelpers.isNullOrEmpty(ticketDetailsLookupError) && <small className='text-danger'>{ ticketDetailsLookupError }</small>
                                                        }
                                                        <small className='invalid-feedback text-danger'>Please enter a VRM</small>
                                                    </div>
                                                </div>
                                                <div className="row align-items-center mb-2">
                                                    <label class="col-sm-4 col-form-label col-form-label-sm">Vehicle Make</label>
                                                    <div className="col-sm-8">
                                                        <input className="form-control form-control-sm" type="text" value={lookupMake} onChange={(e) => setLookupMake(e.target.value)} />
                                                    </div>
                                                </div>
                                                <div className="row align-items-center mb-2">
                                                    <label class="col-sm-4 col-form-label col-form-label-sm">Vehicle Model</label>

                                                    <div className="col-sm-8">
                                                        <input className="form-control form-control-sm" type="text" value={lookupModel} onChange={(e) => setLookupModel(e.target.value)} />
                                                    </div>
                                                </div>
                                                <div className="row align-items-center mb-2">
                                                    <label class="col-sm-4 col-form-label col-form-label-sm">Vehicle Colour</label>
                                                    <div className="col-sm-8">
                                                        <input className="form-control form-control-sm" type="text" value={lookupColour} onChange={(e) => setLookupColour(e.target.value)} />
                                                    </div>
                                                </div>
                                            </>}
                                        </div>
                                        <div>
                                            <div className="row mb-2">
                                                <label class="col-sm-4 col-form-label col-form-label-sm">Number of Breaches</label>
                                                <div className="col-sm-8">
                                                    <p class="form-control-plaintext form-control-sm outline-none" >{ numberOfBreaches }</p>
                                                </div>
                                            </div>

                                            { !roleUtilities.isOrganisationProcessor(props.user, props.organisationId) && <div className="row mb-2">
                                                <label class="col-sm-4 col-form-label col-form-label-sm">Contravention{ticketDetailsInEdit && <span className="req"></span>}</label>
                                                <div className=" col-sm-8">
                                                    {
                                                        !ticketDetailsInEdit
                                                            ? <p class="form-control-plaintext form-control-sm outline-none">
                                                                { breach?.contraventionName } ({Enums.ContraventionTypes[allContraventions?.find(item => item.id === contraventionId)?.contraventionType]})
                                                            </p>
                                                            : <div>
                                                                <select disabled={ status !== 0 } class="custom-select custom-select-sm" onChange={ (e) => {
                                                                    if (stringHelpers.isNullOrEmpty(e.target.value)) {
                                                                        setContraventionValidation("Please select a contravention")
                                                                    } else {
                                                                        setContraventionValidation(null)
                                                                    }
                                                                    setContraventionId(e.target.value)
                                                                } }>
                                                                                                                                                                                                                        <option value="">Select a contravention</option>
                                                                    { siteContraventions && siteContraventions !== null && siteContraventions.length > 0 &&
                                                                        <>
                                                                            { siteContraventions.map((siteContravention) => {
                                                                                let contravention = null;
                                                                                if (allContraventions && allContraventions !== null && allContraventions.length > 0) {
                                                                                    allContraventions.forEach(x => {
                                                                                        if (siteContravention.contraventionId === x.id) {
                                                                                            contravention = x;
                                                                                        }
                                                                                    });
                                                                                }
                                                                                return <option value={ contravention.id } selected={ contravention.id === contraventionId }>{ contravention.name } ({Enums.ContraventionTypes[contravention.contraventionType]})</option>
                                                                            }) }
                                                                        </>
                                                                    }
                                                                </select>
                                                            {!stringHelpers.isNullOrEmpty(contraventionValidation) && <small className='text-danger'>{contraventionValidation}</small>}
                                                            </div>
                                                    }

                                                </div>
                                            </div> }

                                            <div className="row mb-2">
                                                <label class="col-sm-4 col-form-label col-form-label-sm">Duplicate Ticket Check</label>
                                                <div className="col-sm-8">
                                                    <p class="form-control-plaintext form-control-sm outline-none" >
                                                        { dupeTicket === null &&
                                                            <>No Duplicates Found</>
                                                        }
                                                        { dupeTicket !== null &&
                                                            <Link>{ dupeTicket.referenceNumber }</Link>
                                                        }
                                                    </p>
                                                </div>
                                            </div>

                                            { breach.parkingSession !== null &&
                                                <>
                                                    { !arrayUtilities.isNullOrEmpty(allContraventions) && allContraventions.find(x => x.id === contraventionId)?.contraventionType === 1 &&
                                                        <>
                                                            <div className="row mb-2">
                                                                <label class="col-sm-4 col-form-label col-form-label-sm">Observed from{ticketDetailsInEdit && <span className="req"></span>}</label>
                                                                <div className="col-sm-8">
                                                                    {
                                                                        !ticketDetailsInEdit
                                                                            ? <p class="form-control-plaintext form-control-sm outline-none">
                                                                                { toDateTimeString(breach.parkingSession?.entry?.timestamp, true) }
                                                                            </p>
                                                                            : <div>
                                                                                <input required className="form-control form-control-sm" type="datetime-local" value={ toInputFieldDateTimeString(observedFrom) } onChange={ (e) => {
                                                                                setObservedFrom(e.target.value)
                                                                                setDuration(durationBetweenString(e.target.value, observedTo))
                                                                            } } />
                                                                            {stringHelpers.isNullOrEmpty(observedFrom) && <small className='text-danger'>Please enter a date</small>}
                                                                            </div>
                                                                    }
                                                                </div>
                                                            </div>

                                                            <div className="row mb-2">
                                                                <label class="col-sm-4 col-form-label col-form-label-sm">Observed to{ticketDetailsInEdit && <span className="req"></span>}</label>
                                                                <div className="col-sm-8">
                                                                    {
                                                                        !ticketDetailsInEdit
                                                                            ? <p class="form-control-plaintext form-control-sm outline-none m-0">
                                                                                { toDateTimeString(breach.parkingSession?.exit?.timestamp, true) }
                                                                            </p>
                                                                            : <div>
                                                                                <input required className="form-control form-control-sm" type="datetime-local" value={ toInputFieldDateTimeString(observedTo) } onChange={ (e) => {
                                                                                setObservedTo(e.target.value)
                                                                                setDuration(durationBetweenString(observedFrom, e.target.value))
                                                                            } } />
                                                                             {stringHelpers.isNullOrEmpty(observedTo) && <small className='text-danger'>Please enter a date</small>}
                                                                            </div>
                                                                    }
                                                                </div>
                                                            </div>
                                                        </>
                                                    }

                                                    <div className="row mb-2">
                                                        <label class="col-sm-4 col-form-label col-form-label-sm">Duration</label>
                                                        <div className="col-sm-8">
                                                            <p class="form-control-plaintext form-control-sm outline-none">{ duration }</p>
                                                        </div>
                                                    </div>

                                                    
                                                </>
                                            }
                                        </div>
                                    </div>
                                    <div className='d-flex justify-content-end'>
                                        {
                                            !isThirdPartyUser && !roleUtilities.isOrganisationProcessor(props.user, props.organisationId) &&

                                            <>
                                                {
                                                    !ticketDetailsInEdit
                                                        ? <button className="btn-sm btn btn-falcon-default" onClick={ () => setTicketDetailsInEdit(true) }><i className="fas fa-edit mr-1"></i>Edit Ticket Details</button>
                                                        : <>
                                                            <button className="btn-sm btn btn-danger mr-1" onClick={ () => {
                                                                setObservedFrom(breach?.parkingSession?.entry?.timestamp)
                                                                setObservedTo(breach?.parkingSession?.exit?.timestamp)
                                                                setDuration(durationBetweenString(breach?.parkingSession?.entry?.timestamp, breach?.parkingSession?.exit?.timestamp))
                                                                setContraventionId(breach.contraventionId)
                                                                setVrm(breach.vrm)
                                                                setLookupMake(breach.vehicleMake);
                                                                setLookupColour(breach.vehicleColour);
                                                                setLookupModel(breach.vehicleModel);
                                                                setSelectedSiteByClient(breach.siteId)
                                                                setTicketDetailsInEdit(false)
                                                            } }><i className="fas fa-times mr-1"></i>Cancel</button>
                                                            <button disabled={ stringHelpers.isNullOrEmpty(vrm) || stringHelpers.isNullOrEmpty(contraventionId) || stringHelpers.isNullOrEmpty(selectedSiteByClient) || stringHelpers.isNullOrEmpty(observedFrom) || stringHelpers.isNullOrEmpty(observedTo) } className="btn-sm btn btn-success mx-1" onClick={ () => editBreach(selectedSiteByClient) }><i className="fas fa-check mr-1"></i>Confirm</button>
                                                        </>
                                                }
                                            </>

                                        }
                                    </div>

                                    {!arrayUtilities.isNullOrEmpty(allContraventions) && allContraventions.find(x => x.id === breach.contraventionId)?.contraventionType === 0 &&
                                    <>
                                        <hr className="border-dashed border-bottom-0"></hr>
                                        <div className="row">
                                            <div className="col-md-6 col-12 ">
                                                <div className="row">
                                                    <div className="col-12 ">
                                                        <p className="font-weight-semi-bold text-center mt-1 mb-2">Camera In</p>
                                                    </div>
                                                </div>
                                                <div className="row">
                                                    <div className="col-6 text-center">
                                                        <p className="font-weight-semi-bold ">Date</p>
                                                    </div>
                                                    <div className="col-6 text-center">{toDateString(breach.parkingSession?.entry?.timestamp)}</div>
                                                </div>
                                                <div className="row">
                                                    <div className="col-6 text-center">
                                                        <p className="font-weight-semi-bold ">Time</p>
                                                    </div>
                                                    <div className="col-6 text-center">{toTimeString(breach.parkingSession?.entry?.timestamp, true)}</div>
                                                </div>
                                                <div className="row ticket-image-row">
                                                    {breach.parkingSession?.entry?.imageUrls.map((item) => {
                                                        if (item.toString().search("overview") !== -1) {
                                                            var url = item + '?ts=' + timestamp;
                                                            return <RedactionPane {...props} onChange={reloadImages} id={breach.parkingSession?.entry?.id} url={url} />
                                                        } else {
                                                            return (
                                                                <div className="breach-image breach-number-plate">
                                                                    <img src={item} className="py-1" />
                                                                </div>
                                                            )
                                                        }
                                                    })}
                                                </div>
                                            </div>
                                            <div className="col-md-6 col-12 ">
                                                <div className="row">
                                                    <div className="col-12">
                                                        <p className="font-weight-semi-bold text-center mt-1 mb-2">Camera Out</p>
                                                    </div>
                                                </div>
                                                <div className="row">
                                                    <div className="col-6 text-center">
                                                        <p className="font-weight-semi-bold ">Date</p>
                                                    </div>
                                                    <div className="col-6 text-center">{toDateString(breach.parkingSession?.exit?.timestamp)}</div>
                                                </div>
                                                <div className="row">
                                                    <div className="col-6 text-center">
                                                        <p className="font-weight-semi-bold ">Time</p>
                                                    </div>
                                                    <div className="col-6 text-center">{toTimeString(breach.parkingSession?.exit?.timestamp, true)}</div>
                                                </div>
                                                <div className="row ticket-image-row">
                                                    {breach.parkingSession?.exit?.imageUrls.map((item) => {
                                                        if (item.toString().search("overview") !== -1) {
                                                            var url = item + '?ts=' + timestamp;
                                                            return <RedactionPane {...props} onChange={reloadImages} id={breach.parkingSession?.exit?.id} url={url} />
                                                        } else {
                                                            return (
                                                                <div className="breach-image breach-number-plate">
                                                                    <img src={item} className="py-1" />
                                                                </div>
                                                            )
                                                        }
                                                    })}
                                                </div>
                                            </div>
                                        </div>
                                        </>
                                    }
                                </div>
                            </div>
                            <div className="card mb-3">
                                <div className="card-header">
                                    <div className="row align-items-center justify-content-between">
                                        <div className="col-1 d-flex align-items-center pr-0">
                                            <h5 className="fs-0 mb-0 text-nowrap py-2 py-xl-0">Appeals</h5>
                                        </div>
                                        <div className="col-2 text-right pl-0 filter-buttons-wrapper">
                                            <button className="btn btn-success btn-sm ml-1" onClick={addNewAppeal}><i className="fas fa-plus"></i> Add</button>
                                        </div>
                                    </div>
                                </div>
                                <div className="card-body bg-light border-top details-container p-0">
                                    <table className="table table-sm mb-0 table-striped table-dashboard fs--1 data-table border-bottom border-200 no-footer ">
                                        <thead>
                                            <tr>
                                                <th>Name</th>
                                                <th>Contact Type</th>
                                                <th>Contact Source</th>
                                                <th className="text-center">Status</th>
                                                <th className="text-center">Date Received</th>
                                                <th className="text-center">Actions</th>
                                            </tr>
                                        </thead>
                                        {appeals !== null && appeals.length > 0 &&
                                            <tbody>
                                                {appeals.map((appeal) => {
                                                    var appealUrl = "/organisation/" + props.organisationId + "/breach/" + breachId + "/appeal/" + appeal.id;
                                                    return (
                                                        <>
                                                            <tr>
                                                                <td><Link to={appealUrl}><h6 className="my-0">{stringHelpers.contactDetailsName(appeal.contactDetails)}</h6></Link></td>
                                                                <td>{Enums.ContactTypes[appeal.contactDetails.contactType]}</td>
                                                                <td>{Enums.ContactSource[appeal.contactDetails.contactSource]}</td>
                                                                <td className="text-center">

                                                                    {appeal.appealStatus === 0 &&
                                                                        <span className="badge badge rounded-pill badge-warning">{Enums.AppealStatus[appeal.appealStatus]}</span>
                                                                    }
                                                                    {appeal.appealStatus === 1 &&
                                                                        <span className="badge badge rounded-pill badge-success">{Enums.AppealStatus[appeal.appealStatus]}</span>
                                                                    }
                                                                    {appeal.appealStatus === 2 &&
                                                                        <span className="badge badge rounded-pill badge-danger">{Enums.AppealStatus[appeal.appealStatus]}</span>
                                                                    }
                                                                </td>
                                                                <td className="text-center">{toDateTimeString(appeal.timestamp)} - {timeAgo(appeal.timestamp)}</td>
                                                                <td className="text-center">
                                                                    <button className="btn btn-falcon-default btn-sm dropdown-toggle py-2 mr-3 dropdown-caret-none m-auto" type="button" data-toggle="dropdown" aria-haspopup="true" aria-expanded="true"><i className="fas fa-ellipsis-h"></i></button>
                                                                    <div className="dropdown-menu dropdown-menu-right" x-placement="bottom-start">
                                                                        <Link to={appealUrl} type="button" className="dropdown-item btn-sm"><div className="icon-container"><i className="fas fa-envelope"></i></div> View Details</Link>
                                                                        <button type="button" className="dropdown-item btn-sm" data-toggle="modal" data-target={`#delete-appeal-${appeal.id}`}><i className="fas fa-times"></i> Delete Appeal</button>
                                                                    </div>
                                                                </td>
                                                            </tr>
                                                            <div className="modal fade" id={`delete-appeal-${appeal.id}`} tabIndex="-1" role="dialog" aria-labelledby="deleteModalLabel" aria-hidden="true">
                                                                <div className="modal-dialog" role="document">
                                                                    <div className="modal-content">
                                                                        <div className="modal-header">
                                                                            <h5 className="modal-title" id="deleteModalLabel">Are you sure you want to delete this appeal?</h5>
                                                                            <button type="button" className="close" data-dismiss="modal" aria-label="Close">
                                                                                <span aria-hidden="true">&times;</span>
                                                                            </button>
                                                                        </div>
                                                                        <div className='modal-body'>
                                                                            <p>Deleting an appeal is permenant, and won't affect the breach status</p>
                                                                        </div>
                                                                        <div className="modal-footer">
                                                                            <button type="button" className="btn btn-falcon-default btn-sm ml-2" data-dismiss="modal">Cancel</button>
                                                                            <button type="button" className="btn btn-danger btn-sm ml-2" data-dismiss="modal" onClick={() => deleteAppeal(appeal.id)}>
                                                                                Delete</button>
                                                                        </div>
                                                                    </div>
                                                                </div>
                                                            </div>
                                                        </>
                                                    )
                                                })}
                                            </tbody>
                                        }
                                    </table>
                                </div>
                            </div>

                            <div className="card mb-3">
                                <div className="card-header">
                                    <div className="row align-items-center justify-content-between">
                                        <div className="col-1 d-flex align-items-center pr-0">
                                            <h5 className="fs-0 mb-0 text-nowrap py-2 py-xl-0">Transfer of Liability</h5>
                                        </div>
                                        <div className="col-2 text-right pl-0 filter-buttons-wrapper">
                                            <button className="btn btn-success btn-sm ml-1" onClick={addNewTransfer}><i className="fas fa-plus"></i> Add</button>
                                        </div>
                                    </div>
                                </div>
                                <div className="card-body bg-light border-top p-0 details-container">
                                    <table className="table table-sm mb-0 table-striped table-dashboard fs--1 data-table border-bottom border-200 no-footer ">
                                        <thead>
                                            <tr>
                                                <th>Notifier</th>
                                                <th>Liable Party</th>
                                                <th>Contact Type</th>
                                                <th>Contact Source</th>
                                                <th className="text-center">Date Received</th>
                                                <th>Status</th>
                                                <th className="text-center">Actions</th>
                                            </tr>
                                        </thead>
                                        <tbody>
                                            {!arrayUtilities.isNullOrEmpty(transfers)
                                                && transfers.map(transfer => {
                                                    const transferUrl = `/organisation/${props.organisationId}/breach/${breachId}/transfer-of-liability/${transfer.id}`
                                                    return <tr>
                                                        <td><Link to={transferUrl}><h6 className="my-0">{stringHelpers.contactDetailsName(transfer.liabilityNotifierContact)}</h6></Link></td>
                                                        <td><Link to={transferUrl}><h6 className="my-0">{stringHelpers.contactDetailsName(transfer.liabilityPartyContact)}</h6></Link></td>
                                                        <td>{Enums.ContactTypes[transfer.liabilityNotifierContact.contactType]}</td>
                                                        <td>{Enums.ContactSource[transfer.liabilityNotifierContact.contactSource]}</td>
                                                        <td className="text-center">{toDateTimeString(transfer.liabilityNotifierContact.timestamp)} - {timeAgo(transfer.liabilityNotifierContact.timestamp)}</td>
                                                        <td>{Enums.TransferOfLiabilityStatus[transfer.transferOfLiabilityStatus]}</td>
                                                        <td className="text-center">
                                                            <button className="btn btn-falcon-default btn-sm dropdown-toggle py-2 mr-3 dropdown-caret-none m-auto" type="button" data-toggle="dropdown" aria-haspopup="true" aria-expanded="true"><i className="fas fa-ellipsis-h"></i></button>
                                                            <div className="dropdown-menu dropdown-menu-right" x-placement="bottom-start">
                                                                <Link to={transferUrl} type="button" className="dropdown-item btn-sm"><div className="icon-container"><i className="fas fa-envelope"></i></div> View Details</Link>
                                                            </div>
                                                        </td>
                                                    </tr>
                                                })

                                            }
                                        </tbody>
                                    </table>
                                </div>
                            </div>

                            <BreachPayments canUpdate={!isThirdPartyUser && !roleUtilities.isOrganisationProcessor(props.user, props.organisationId)} breachId={breach.id} organisationId={props.organisationId} token={props.token} getBreach={getBreach} />
                            <div className="card mb-3">
                                <div className="card-header">
                                    <div className="row align-items-center justify-content-between">
                                        <div className="col-1 d-flex align-items-center pr-0">
                                            <h5 className="fs-0 mb-0 text-nowrap py-2 py-xl-0">Additional Charges</h5>
                                        </div>
                                        {(roleUtilities.isOrganisationAdminOrManager(props.user, props.organisationId) || isThirdPartyUser || roleUtilities.isOrganisationProcessor(props.user, props.organisationId)) && 
                                        <div className="col-2 text-right pl-0 filter-buttons-wrapper">
                                            <button className="btn btn-success btn-sm ml-1" onClick={ () => {
                                                    setAdditionalChargeAmount("")
                                                    setAdditionalChargeDescription("")
                                                    setShowAddCharge(true)
                                                } }><i className="fas fa-plus"></i> Add</button>
                                        </div>}
                                    </div>
                                </div>
                                <div className="card-body bg-light border-top p-0 details-container">
                                    <table className="table table-sm mb-0 table-striped table-dashboard fs--1 data-table border-bottom border-200 no-footer ">
                                        <thead>
                                            <tr>
                                                <th>Date/Time</th>
                                                <th>Amount</th>
                                                <th>Description</th>
                                                <th>&nbsp;</th>
                                            </tr>
                                        </thead>
                                        { !arrayUtilities.isNullOrEmpty(additionalCharges) &&
                                            <tbody>
                                                { additionalCharges.map(charge =>
                                                    <tr>
                                                        <td>{ toDateTimeString(charge.timestamp)} </td>
                                                        <td>£{ charge.amount.toFixed(2) }</td>
                                                        <td>{ charge.description }</td>
                                                        { (roleUtilities.isOrganisationAdminOrManager(props.user, props.organisationId) || isThirdPartyUser) || roleUtilities.isOrganisationProcessor(props.user, props.organisationId) && <td className='text-right pr-3'>
                                                            <button onClick={ () => {
                                                                setAdditionalChargeId(charge.id);
                                                                setAdditionalChargeAmount(String(charge.amount))
                                                                setAdditionalChargeDescription(charge.description)
                                                                setShowAddCharge(true);
                                                            } } className='btn p-0 mr-1'><i className="far fa-edit"></i></button>
                                                            <button onClick={ () => { setAdditionalChargeId(charge.id); setShowDeleteCharge(true); } } className='btn p-0'><i className="fas fa-trash-alt"></i></button>
                                                        </td> }
                                                    </tr>
                                                ) }
                                            </tbody>
                                        }
                                    </table>
                                </div>
                            </div>

                            <Modal show={ showAddCharge } size="lg">
                                <Modal.Header>
                                    <Modal.Title>
                                        Add an Additional Charge
                                    </Modal.Title>
                                </Modal.Header>
                                <Modal.Body>
                                    <div className="row">
                                        <div className="col-12 ">
                                            <p className="font-weight-semi-bold  mt-1 mb-2">Amount:</p>
                                        </div>
                                        <div className="col-12">
                                            <div className="form-group mb-0">
                                                <input className="form-control" type='number' step="0.01" value={ additionalChargeAmount } onChange={ (e) => setAdditionalChargeAmount(e.target.value) } />
                                            </div>
                                        </div>
                                    </div>
                                    <div className="row">
                                        <div className="col-12 ">
                                            <p className="font-weight-semi-bold  mt-1 mb-2">Description:</p>
                                        </div>
                                        <div className="col-12">
                                            <div className="form-group mb-0">
                                                <textarea rows={ 3 } className="form-control" value={ additionalChargeDescription } onChange={ (e) => setAdditionalChargeDescription(e.target.value) } />
                                            </div>
                                        </div>
                                    </div>
                                </Modal.Body>
                                <Modal.Footer>
                                    <button className="btn btn-sm btn-danger mt-1" onClick={ () => {
                                        setAdditionalChargeAmount("")
                                        setAdditionalChargeDescription("")
                                        setShowAddCharge(false)
                                    } }>Cancel</button>
                                    <button className="btn btn-sm btn-success mt-1" disabled={ stringHelpers.isNullOrEmpty(additionalChargeAmount) } onClick={ saveAdditionalCharge }>Save</button>
                                </Modal.Footer>
                            </Modal>

                            <Modal show={ showDeleteCharge } size="md">
                                <Modal.Header>
                                    <Modal.Title>
                                        Delete additional charge
                                    </Modal.Title>
                                </Modal.Header>
                                <Modal.Body>
                                    Are you sure you want to delete this additional charge?
                                </Modal.Body>
                                <Modal.Footer>
                                    <button className="btn btn-falcon-default btn-sm mt-1" onClick={ () => setShowDeleteCharge(false) }>Cancel</button>
                                    <button type="button" className="btn btn-danger btn-sm ml-2" data-dismiss="modal"
                                        onClick={ () => {
                                            Api.deleteAdditionalCharge(
                                                data => {
                                                    if (data.isError) {
                                                        setShowDeleteCharge(false);
                                                        setErrorMessage(data.errorMessage)
                                                    } else {
                                                        setShowDeleteCharge(false);
                                                        getAdditionalCharges();
                                                        getBreach()
                                                    }
                                                },
                                                error => {
                                                    console.log(error)
                                                    setShowDeleteCharge(false);
                                                    setErrorMessage(error.message)
                                                },
                                                breachId, additionalChargeId, props.organisationId, props.token,
                                            )
                                        } }
                                    >
                                        Delete
                                    </button>
                                </Modal.Footer>
                            </Modal>

                            {!stringHelpers.isNullOrEmpty(vrm) && site && site !== null &&
                                <AllowedVrms vrm={vrm} siteId={site.id} organisationId={props.organisationId} token={props.token} />
                            }

                            <div className="card mb-3">
                                <div className="card-header">
                                    <div className="row align-items-center">
                                        <div className="col">
                                            <h5 className="mb-0">
                                                <button className="button-no-style button-card-header collapsed" id="contact-details" type="button" data-toggle="collapse" data-target="#contact-details-list" aria-expanded="true" aria-controls="recent-visits-list">
                                                    Contact History <i className="fas fa-chevron-down"></i>
                                                </button>
                                            </h5>
                                        </div>
                                        {!roleUtilities.isThirdPartyProcessor(props.user, props.organisationId) && !roleUtilities.isOrganisationProcessor(props.user, props.organisationId) && <div className="col-2 text-right pl-0 filter-buttons-wrapper">
                                            <Link className="btn btn-success btn-sm ml-1" to={newContactUrl}><i className="fas fa-plus"></i> Add</Link>
                                        </div>}
                                    </div>
                                </div>
                                <div className="card-body bg-light border-top details-container p-0 collapse" id="contact-details-list" aria-labelledby="Allow List" data-parent="#contact-details">
                                    <table className="table table-sm mb-0 table-striped table-dashboard fs--1 data-table border-bottom border-200 no-footer ">
                                        <thead className="bg-200 text-900">
                                            <tr>
                                                <th>Name</th>
                                                <th>Contact Type</th>
                                                <th>Contact Source</th>
                                                <th className="text-center">Status</th>
                                                <th>&nbsp;</th>
                                            </tr>
                                        </thead>
                                        <tbody>
                                            {!arrayUtilities.isNullOrEmpty(contactDetailsList) && contactDetailsList.map((item) => {
                                                var url = '/organisation/' + props.organisationId + '/breach/' + breachId + '/contact-details/' + item.id;
                                                return (
                                                    <>
                                                        <tr>
                                                            <td><Link className="button-no-style" to={url}><h6 className="mb-0">{stringHelpers.contactDetailsName(item)}</h6></Link></td>
                                                            <td>{Enums.ContactTypes[item.contactType]}</td>
                                                            <td>{Enums.ContactSource[item.contactSource]}</td>
                                                            <td className="text-center">{item.isActive && <><i className="fas fa-check text-success"></i></>}{!item.isActive && <><i className="fas fa-times text-danger"></i></>}</td>
                                                            {!isThirdPartyUser && !roleUtilities.isOrganisationProcessor(props.user, props.organisationId) && <td className="text-right">
                                                                <Link to={{
                                                                    pathname: url,
                                                                    state: {
                                                                        editMode: true
                                                                    }
                                                                }} className='btn btn-link'><i className="fas fa-edit text-secondary"></i></Link>
                                                            </td>}
                                                        </tr>
                                                    </>
                                                )
                                            })}
                                        </tbody>
                                    </table>
                                </div>
                            </div>

                            {!stringHelpers.isNullOrEmpty(vrm) && site && site !== null &&
                                <Payments vrm={vrm} breachDate={breach.timestamp} siteId={site.id} organisationId={props.organisationId} token={props.token} lookupDataInEdit={lookupDataInEdit} paymentsFromDate={paymentsFromDate} setPaymentsFromDate={setPaymentsFromDate} paymentsToDate={paymentsToDate} setPaymentsToDate={setPaymentsToDate} />
                            }

                            <div className="card mb-3">
                                <div className="card-header">
                                    <div className="row align-items-center">
                                        <div className="col">
                                            <h5 className="mb-0">
                                                <button className="button-no-style button-card-header collapsed" id="recent-contras" type="button" data-toggle="collapse" data-target="#recent-contras-list" aria-expanded="true" aria-controls="recent-contras-list">
                                                    Previous Contraventions&nbsp;
                                                    <span className="translate-middle badge rounded-pill bg-danger">
                                                        {previousContraventions !== null && <>{previousContraventions.length}</>}
                                                    </span>
                                                    &nbsp;<i className="fas fa-chevron-down"></i>
                                                </button>
                                            </h5>
                                        </div>
                                    </div>
                                </div>
                                <div className="card-body bg-light border-top details-container p-0 collapse" id="recent-contras-list" aria-labelledby="Allow List" data-parent="#recent-contras">
                                    <table className="table table-sm mb-0 table-striped table-dashboard fs--1 data-table border-bottom border-200 no-footer ">
                                        <thead className="bg-200 text-900">
                                        <tr>
                                            <th>PCN</th>
                                            <th className="text-center">VRM</th>
                                            <th className="text-center">Contravention Date</th>
                                            <th className="text-center">Last Image/Read</th>
                                            <th>Contravention</th>
                                            <th>Site</th>
                                            <th>Status</th>
                                            <th>Outstanding Charges</th>
                                        </tr>
                                        </thead>
                                        <tbody>
                                            {!arrayUtilities.isNullOrEmpty(previousContraventions) &&

                                                <>
                                                    {previousContraventions.map((item) => {
                                                        var url = "/organisation/" + props.organisationId + "/breach/" + item.id;
                                                        var balance = '£' + (Math.round(item.outstandingBalance * 100) / 100).toFixed(2);
                                                        return (<tr>
                                                                <td><Link to={url}><h6
                                                                    className="mb-0">{item.referenceNumber}{item.referenceNumber === null && <>Unknown</>}</h6>
                                                                </Link></td>
                                                                <td className="text-center"><h6
                                                                    className="m-auto mb-0 small-number-plate">{item.vrm}</h6>
                                                                </td>
                                                                <td className="text-center">{item.timestamp !== null && <>{toDateString(item.timestamp)}</>}</td>
                                                                <td className="text-center">
                                                                    {item.parkingSession !== null && item.parkingSession.exit !== null && <>{toDateTimeString(item.parkingSession.exit.timestamp)}</>}
                                                                </td>
                                                                <td>{item.contraventionName}</td>
                                                                <td>{item.siteName}</td>
                                                                <td>{Enums.BreachStatus[item.breachStatus]}</td>
                                                                <td className="text-right">{balance}</td>
                                                            </tr>)
                                                    })}
                                                </>}
                                        </tbody>
                                    </table>
                                </div>
                            </div>

                            <div className="card mb-3">
                                <div className="card-header">
                                    <div className="row align-items-center justify-content-between">
                                        <div className="col-2">
                                            <h5 className="mb-0">
                                                <button className="button-no-style button-card-header collapsed" id="attachments" type="button" data-toggle="collapse" data-target="#attachments-list" aria-expanded="true" aria-controls="attachments">
                                                    Attachments &nbsp;
                                                    {attachments !== null &&
                                                        <span className="translate-middle badge rounded-pill bg-success">
                                                            <>{attachments.length}</>
                                                        </span>
                                                    }
                                                    &nbsp;<i className="fas fa-chevron-down"></i>
                                                </button>
                                            </h5>
                                        </div>
                                        <div className="col-auto text-right pl-0 filter-buttons-wrapper">
                                            <button className="btn btn-success btn-sm ml-1" data-toggle="modal" data-target="#add-new-evidence" ><i className="fas fa-plus"></i> Add</button>
                                            <Link to={{
                                                    pathname: `/organisation/${ props.organisationId }/breach/${ breachId }/new-letter`,
                                                    state: { siteId: site?.id }
                                                }} 
                                                className="btn btn-primary btn-sm ml-1"><i className="fas fa-envelope mr-2"></i>New Letter</Link>
                                        </div>
                                    </div>
                                </div>
                                <div className="card-body bg-light border-top details-container p-2 collapse" id="attachments-list" aria-labelledby="Allow List" data-parent="#attachments">
                                    { attachments && <BreachAttachmentsDisplay
                                        attachments={ attachments }
                                        imageAttachments={ imageAttachments }
                                        onChange={ reloadImages }
                                        showIsLetterImage={ !isThirdPartyUser && !roleUtilities.isOrganisationProcessor(props.user, props.organisationId) }
                                        onIsLetterImageChange={ attachmentIsLetterImage }
                                        organisationId={ props.organisationId }
                                        token={ props.token }
                                        userId={ props.user.id }
                                        onDeleteClick={attachmentId => setDeleteAttachmentId(attachmentId)}
                                        isOldLayout
                                    /> }
                                </div>
                                {
                                    !stringHelpers.isNullOrEmpty(deleteAttachmentId) &&
                                    <Modal key="delete-attachment-modal" show size="md">
                                        <Modal.Header>
                                            <Modal.Title className='text-danger'>
                                                Delete Attachment
                                            </Modal.Title>
                                        </Modal.Header>
                                        <Modal.Body>Are you sure you want to delete this attachment?</Modal.Body>
                                        <Modal.Footer>
                                            <button className="btn btn-falcon-default btn-sm mt-1" onClick={ () => setDeleteAttachmentId(null) }>Cancel</button>
                                            <button type="button" className="btn btn-danger btn-sm ml-2"
                                                onClick={ () => {
                                                    console.log("delete in progress...")
                                                    Api.deleteBreachAttachment(
                                                        data => {
                                                            if (data.isError) {
                                                                setErrorMessage(data.errorMessage)
                                                            } else {
                                                                setDeleteAttachmentId(null);
                                                            }
                                                            getBreach()
                                                            setDeleteAttachmentId(null)
                                                        },
                                                        error => {
                                                            console.log(error)
                                                            setDeleteAttachmentId(null)
                                                            setErrorMessage(error.errorMessage)
                                                        }, breachId, deleteAttachmentId,
                                                        props.organisationId, props.token,

                                                    )
                                                } }
                                            >
                                                Delete
                                            </button>
                                        </Modal.Footer>
                                    </Modal> }
                            </div>


                            <div className="modal fade save-dialog success-dialog" id="add-new-evidence" tabIndex="-1" role="dialog">
                                <UploadFile onSuccess={(file) => attachFile(file)} type="Attachments" organisationId={props.organisationId} />
                            </div>

                            <div className="card mb-3">
                                <div className="card-header">
                                    <div className="row align-items-center justify-content-between">
                                        <div className="col-2">
                                            <h5 className="mb-0">
                                                <button className="button-no-style button-card-header collapsed" id="note-button" type="button" data-toggle="collapse" data-target="#notes" aria-expanded="true" aria-controls="site-details">
                                                    Notes &nbsp;
                                                    {!arrayUtilities.isNullOrEmpty(breach.breachLogs) &&
                                                        <span className="translate-middle badge rounded-pill bg-success">
                                                            <>{breach.breachLogs.length}</>
                                                        </span>
                                                    }
                                                    &nbsp;<i className="fas fa-chevron-down"></i>
                                                </button>
                                            </h5>
                                        </div>
                                        {!isThirdPartyUser && !roleUtilities.isOrganisationProcessor(props.user, props.organisationId) && <div className="col-2 text-right pl-0 filter-buttons-wrapper">
                                            <button className="btn btn-success btn-sm ml-1" data-toggle="modal" data-target="#note-modal" ><i className="fas fa-plus"></i> Add</button>
                                        </div>}
                                    </div>
                                </div>
                                <div className="modal fade" id="note-modal" tabIndex="-1" role="dialog" aria-labelledby="On Hold Modal" aria-hidden="true">
                                    <div className="modal-dialog" role="document">
                                        <div className="modal-content">
                                            <div className="modal-header">
                                                <h5 className="modal-title" id="deleteModalLabel">Add a note.</h5>
                                                <button type="button" className="close" data-dismiss="modal" aria-label="Close">
                                                    <span aria-hidden="true">&times;</span>
                                                </button>
                                            </div>
                                            <div className="modal-body">
                                                <div className="row">
                                                    <div className="col-12 ">
                                                        <p className="font-weight-semi-bold  mt-1 mb-2">Note:</p>
                                                    </div>
                                                    <div className="col-12">
                                                        <div className="form-group mb-0">
                                                            <textarea className="form-control mb-0" rows={4} value={note} onChange={(e) => setNote(e.target.value)} />
                                                        </div>
                                                    </div>
                                                </div>
                                            </div>
                                            <div className="modal-footer">
                                                <button type="button" className="btn btn-falcon-default btn-sm ml-2" data-dismiss="modal">Cancel</button>
                                                <button disabled={stringHelpers.isNullOrEmpty(note)} type="button" className="btn btn-success btn-sm ml-2" data-dismiss="modal" onClick={() => submitNote()}>
                                                    Confirm</button>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                                <div className="card-body bg-light border-top details-container collapse p-0" id="notes" aria-labelledby="Allow List" data-parent="#note-button">
                                    <table className="table table-sm mb-0 table-striped table-dashboard fs--1 data-table border-bottom border-200 no-footer ">
                                        <thead className="bg-200 text-900">
                                            <tr>
                                                <th>User</th>
                                                <th>Note</th>
                                                <th className="text-center">Date</th>
                                            </tr>
                                        </thead>
                                        <tbody>
                                            {!arrayUtilities.isNullOrEmpty(breach.breachLogs) && breach.breachLogs.map((item) => {
                                                var statusChange = false;
                                                if (item.oldBreachStatus !== item.newBreachStatus) {
                                                    statusChange = true;
                                                }
                                                var onHoldChange = false;
                                                if (item.wasOnHold !== item.isOnHold) {
                                                    onHoldChange = true;
                                                }
                                                return (
                                                    <>
                                                        <tr className="align-items-center">
                                                            <td><button className="button-no-style pt-1 mt-1"><h6 className="pt-1">{item.userName !== null && <>{item.userName}</>}{item.userName === null && <>Unknown</>}</h6></button></td>
                                                            <td>

                                                                {statusChange &&
                                                                    <div>
                                                                        {Enums.BreachStatus[item.oldBreachStatus]} <i className="fas fa-arrow-right"></i> {Enums.BreachStatus[item.newBreachStatus]}
                                                                    </div>
                                                                }
                                                                {!stringHelpers.isNullOrEmpty(item.note) &&
                                                                    <div>
                                                                        {item.note}
                                                                    </div>
                                                                }
                                                                {onHoldChange && <>

                                                                    {item.isOnHold &&
                                                                        <div>
                                                                            Placed on hold
                                                                        </div>
                                                                    }
                                                                    {!item.isOnHold &&
                                                                        <div>
                                                                            Taken off hold
                                                                        </div>
                                                                    }
                                                                </>}
                                                            </td>
                                                            <td className="text-center">{toDateTimeString(item.timestamp)}</td>
                                                        </tr>
                                                    </>
                                                )
                                            })}
                                        </tbody>
                                    </table>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </>}
            {
                !stringHelpers.isNullOrEmpty(errorMessage) &&
                <ErrorModal
                    message={errorMessage}
                    onHide={() => setErrorMessage(null)}
                />
            }
        </>
    )
}
export default BreachOldLayout;

